import { ActivatedRouteSnapshot } from '@angular/router';

function findDeepestSnapshot(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let current = route;

  while (current.firstChild) {
    current = current.firstChild;
  }

  return current;
}

export function resolvePagePath(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = findDeepestSnapshot(route);

  while (current) {
    const pagePath = current.data?.['pagePath'];

    if (typeof pagePath === 'string' && pagePath.trim() !== '') {
      return pagePath.trim();
    }

    current = current.parent;
  }

  return null;
}
